import React from 'react'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { Link } from '@mui/material'
import { todokusuriUrl, todokusuriClinicUrl } from 'config/url'

const TodokusuriText: React.FC<{ isMedical?: boolean }> = ({
  isMedical = false,
}) => {
  const { t } = useTranslation()
  return (
    <>
      {t('とどくすりサービスから無料配送またはコンビニで受け取る')}（
      <Link
        href={isMedical ? todokusuriClinicUrl : todokusuriUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('とどくすりサービス')}
      </Link>
      ）
    </>
  )
}

export const howToReceiveMedicineDirectValue = i18next.t(
  'お近くで薬局にて直接受け取る（処方箋は医療機関から郵送、または電子処方箋を利用する）'
)

export default TodokusuriText
